import React, { useEffect, useState } from "react";
import axios from "axios";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const About = () => {
  const [about_data, setAboutData] = useState({});
  const [homeProducts, setHomeProducts] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetchAbouts();
    fetchAboutProducts();
  }, []);
  const fetchAbouts = async () => {
    const response = await axios.post(`${BASE_URL}/api/about/get`);
    setAboutData(response.data.about);
  };
  const fetchAboutProducts = () => {
    axios
      .post(`${BASE_URL}/api/category/get`)
      .then((response) => {
        if (response.data.category.length > 0) {
          setHomeProducts(response.data.category); // Store product data
        }
      })
      .catch((err) => { });
  };


  // --- DATABASE TEXT PARSING LOGIC ---
  // This logic takes the single string from your DB and prepares it for the design
  const fullDescription = about_data?.description || "";

  // Define the 3 specific titles we want to pull into the infographic
  // You can customize these icons and colors
  const promiseItems = [
    {
      title: "Heritage of Trust",
      desc: "Delivering excellence since 1996.",
      color: "#f39c12", // Orange
      icon: "assets/img/icons/heritage.png"
    },
    {
      title: "Uncompromised Quality",
      desc: "Every product undergoes stringent quality checks.",
      color: "#8e44ad", // Purple
      icon: "assets/img/icons/quality.png"
    },
    {
      title: "Design Innovation",
      desc: "A seamless blend of traditional craftsmanship and modern trends.",
      color: "#27ae60", // Green
      icon: "assets/img/icons/design.png"
    }
  ];

  // Extract the Vision part of the text (everything after "Our Vision")
  const visionContent = fullDescription.split("Our Vision")[1] || "";

  return (
    <>
      <main className="main-content site-wrapper-reveal">
        {/* Page Title Area */}
        <section
          className="page-content-area"
          data-bg-img="assets/img/photos/bg-page-title.webp"
          style={{
            backgroundImage: `url("../../assets/img/b2.png")`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-content text-center">
                  <h1 className="title">About Our Legacy</h1>
                </div>
              </div>
            </div>
          </div>
        </section>


        {/* --- 1. HERO & LEGACY SECTION --- */}
        <section className="about-hero-section section-space">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="about-content pe-lg-5">
                  <span className="subtitle-premium">Established 1996</span>
                  <h2 className="title-gold main-display">Excellence in Hospitality <br /><span>Since 1996</span></h2>
                  <div className="title-separator-left"></div>
                  <p className="legacy-text mt-4">
                    Established in 1996, Sachi Products has grown into a trusted and distinguished name in the HoReCa industry.
                    For nearly three decades, we have been synonymous with quality, craftsmanship, and timeless elegance.
                  </p>
                  <p className="legacy-text secondary">
                    At Sachi, we believe that dining is more than a service - it is an experience.
                    Our mission is to elevate that story through thoughtfully designed, high-performance products.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-thumb-container">
                  <div className="image-border-frame">
                    <img
                      src={about_data.image ? `${BASE_URL}/${about_data.image}` : "assets/img/about-legacy.jpg"}
                      alt="Sachi Legacy"
                      className="img-fluid"
                    />
                  </div>
                  <div className="experience-badge">
                    <span className="years">30+</span>
                    <span className="label">Years of <br />Distinction</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* --- 2. PRODUCT PORTFOLIO SECTION (Grid Layout) --- */}
        <section className="portfolio-section section-space bg-light">
          <div className="container">
            <div className="section-title text-center mb-5">
              <h2 className="premium-main-title">OUR PRODUCT <span>PORTFOLIO</span></h2>
              <p className="portfolio-subtitle">Sophistication in every detail</p>
            </div>
            <div className="row g-4">
              {[
                { title: "Crockery & Fine Tableware", desc: "Our premium collections include 100% Melamine, exclusive Sachi Fine Tableware, and high-quality Porcelain. Each piece is designed to combine aesthetic refinement with long-lasting durability—enhancing presentation while meeting the rigorous demands of hospitality environments." },
                { title: "Tea & Coffee Sets", desc: "Elegantly crafted designs that reflect sophistication and polish in every detail, adding grace to every serving experience." },
                { title: "Cutlery & Serving Accessories", desc: "Precision-engineered and perfectly balanced, our cutlery and serving solutions are carefully crafted to ensure comfort, durability, and a premium feel." },
                { title: "Catering & Events", desc: "Tastefully curated products designed for grand celebrations, large-scale catering needs, and memorable Events." },
                { title: "Food Packaging Essentials", desc: "Produced using 100% food-grade, virgin materials, our packaging solutions are reusable, safe, and built to deliver reliable performance without compromising on quality." }
              ].map((item, i) => (
                <div className="col-md-4" key={i}>
                  <div className="portfolio-card">
                    <h4>{item.title}</h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* --- 3. THE SACHI PROMISE (Infographic Layout) --- */}
        <section className="promise-section section-space">
          <div className="container">
            <div className="section-title text-center mb-5">
              <h2 className="premium-main-title">THE SACHI <span>PROMISE</span></h2>
            </div>
            <div className="infographic-wrapper">
              {[
                { title: "Heritage of Trust", color: "#D4AF37", icon: "🤝" },
                { title: "Uncompromised Quality", color: "#5d94c2", icon: "⭐" },
                { title: "Design Innovation", color: "#74aa7a", icon: "🎨" },
                { title: "Customer-Centric", color: "#e0e089", icon: "👤" },
                { title: "Sustainable", color: "#455A64", icon: "🌿" }
              ].map((item, index) => (
                <div className={`capsule-item ${index % 2 !== 0 ? 'reverse' : ''}`} key={index}>
                  <div className="capsule-content" style={{ '--theme-color': item.color }}>
                    <div className="capsule-top">
                      <span className="icon-emoji">{item.icon}</span>
                      <h4 className="value-title">{item.title}</h4>
                    </div>
                    <div className="capsule-bottom">
                      <span className="step-num">0{index + 1}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mission-vision-section section-space">

          <div className="container">
            <div className="row justify-content-center">

              {/* Mission Card */}
              <div className="col-lg-5 col-md-6 mb-4">
                <div className="mv-card mission">
                  <div className="mv-content">

                    <h3>MISSION</h3>
                    <p>
                      A product is only valuable to the consumer if they can use it on time.
                      We ensure our patrons access products with efficiency and reliability.
                    </p>
                  </div>
                  <div className="mv-footer">
                    <span><i className="fas fa-bullseye"></i></span>
                  </div>
                </div>
              </div>

              {/* Vision Card */}
              <div className="col-lg-5 col-md-6 mb-4">
                <div className="mv-card vision">
                  <div className="mv-content">

                    <h3>VISION</h3>
                    <p>
                      We understand the importance of transparency and accountability to
                      build long-term relationships with our global partners.
                    </p>
                  </div>
                  <div className="mv-footer">
                    <span><i className="far fa-lightbulb"></i></span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* --- 4. OUR VISION (Premium Footer Section) --- */}
        {/* <section className="vision-section section-space bg-dark-gold">
          <div className="container">
            <div className="vision-box-large text-center">
              <h2 className="vision-title">Our Vision</h2>
              <p className="main-vision-text">
                "To continue leading the hospitality industry with products that inspire confidence, elegance, and functionality - 
                transforming everyday dining into a refined and luxurious experience."
              </p>
              <div className="vision-separator"></div>
              <p className="vision-subtext">
                At Sachi Products, we help craft experiences where quality meets class, 
                and every detail reflects perfection.
              </p>
            </div>
          </div>
        </section> */}
        <style>{`
        /* 1. Legacy Styles */
        .subtitle-premium { color: #B8860B; font-weight: 700; text-transform: uppercase; letter-spacing: 2px; }
        .title-gold { font-size: 42px; font-weight: 800; color: #1a1a1a; line-height: 1.2; }
        .title-gold span { color: #B8860B; }
        .legacy-text { font-size: 18px; line-height: 1.8; color: #555; margin-top: 20px; }
        .experience-badge { position: absolute; bottom: -20px; right: 0; background: #B8860B; color: #fff; padding: 25px; box-shadow: 10px 10px 0px #494a55; }
        .experience-badge .years { font-size: 40px; font-weight: 900; display: block; line-height: 1; }

        /* 2. Portfolio Styles */
        .portfolio-card { background: #fff; padding: 30px; border-radius: 15px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); height: 100%; border-bottom: 4px solid #B8860B; transition: 0.3s; }
        .portfolio-card:hover { transform: translateY(-10px); }
        .portfolio-card h4 { font-size: 18px; font-weight: 700; margin-bottom: 15px; }

        /* 3. Capsule Styles */
        .infographic-wrapper { display: flex; justify-content: center; gap: 20px; flex-wrap: wrap; padding-top: 40px; }
        .capsule-content { width: 180px; height: 320px; border-radius: 90px; background: #fff; overflow: hidden; display: flex; flex-direction: column; box-shadow: 0 15px 30px rgba(0,0,0,0.1); }
        .capsule-top { flex-grow: 1; background: var(--theme-color); color: #fff; padding: 40px 20px; text-align: center; }
        .icon-emoji { font-size: 40px; display: block; margin-bottom: 15px; }
        .value-title { font-size: 16px; font-weight: 600; line-height: 1.3; }
        .capsule-bottom { height: 70px; display: flex; justify-content: center; align-items: center; font-weight: 900; font-size: 24px; color: #ddd; }
        .capsule-item.reverse { margin-top: 50px; }
        .step-num {color : #000000; }

        /* 4. Vision Styles */
        .bg-dark-gold { background: #1a1a1a; color: #fff; position: relative; overflow: hidden; }
        .vision-title { font-size: 48px; color: #B8860B; margin-bottom: 30px; }
        .main-vision-text { font-size: 24px; font-style: italic; max-width: 900px; margin: 0 auto; line-height: 1.6; opacity: 0.9; }
        .vision-separator { width: 100px; height: 2px; background: #B8860B; margin: 30px auto; }
        .vision-subtext { font-size: 18px; opacity: 0.7; }

        @media (max-width: 768px) {
          .infographic-wrapper { flex-direction: column; align-items: center; }
          .capsule-item.reverse { margin-top: 0; }
          .title-gold { font-size: 32px; }
        }
      `}</style>
      </main>
    </>
  );
};
export default About;
